import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { request, type ApiError } from '../../api/client';
import { Notice } from '../../components/primitives';

interface SiteIntegrationsResponse {
  providers: {
    id: string;
    label: string;
    status: 'configured' | 'unconfigured';
  }[];
}

export function SiteIntegrationsScreen() {
  const { t } = useTranslation('common');
  const query = useQuery({
    queryKey: ['site-integrations'],
    queryFn: () => request<SiteIntegrationsResponse>('/site/integrations'),
  });

  if (query.isPending) {
    return <p className="org-state">{t('site_admin.loading_integrations')}</p>;
  }

  if (query.isError) {
    const err = query.error as ApiError;
    return <Notice referenceId={err.correlationId}>{err.message}</Notice>;
  }

  return (
    <section className="org__card">
      <p className="org__eyebrow">{t('site_admin.deployment_integrations_title')}</p>
      <div className="org__list">
        {query.data.providers.map((provider) => (
          <div
            key={provider.id}
            className="org__list-item"
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
          >
            <div>
              <div style={{ fontWeight: 600 }}>{provider.label}</div>
              <div style={{ fontSize: 13, color: 'var(--ink-light)' }}>
                {provider.status === 'configured'
                  ? t('site_admin.configured_env')
                  : t('site_admin.unconfigured_env')}
              </div>
            </div>
            <div>
              <span
                className={`org__badge org__badge--${provider.status === 'configured' ? 'blue' : 'gray'}`}
              >
                {provider.status}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
